module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/undo.0c8ae816.svg";